// extracted by mini-css-extract-plugin
export var brand = "_b0-9";
export var compact = "_b0-6";
export var extraSmall = "_b0-7";
export var icon = "_b0-0";
export var large = "_b0-4";
export var light = "_b0-1";
export var medium = "_b0-5";
export var outline = "_b0-b";
export var primaryDark = "_b0-a";
export var primaryLight = "_b0-8";
export var primaryModern = "_b0-c";
export var success = "_b0-2";
export var successSolid = "_b0-3";